import { ReactElement } from 'react';
import { Modal } from '@weareopenr/component-library';
import { usePricingCategories } from 'src/hooks/usePricingCategories';
import { CategoryOverrideRuleModalContent, CategoryOverrideRuleSteps } from './CategoryOverrideRuleModalContent';
import { IPriceRule } from 'src/types/price.types';

type CategoryOverrideRuleModalProps = {
  open: boolean;
  closeModal: () => void;
  priceSchemeId: string;
  // Edit mode
  ruleToEdit?: IPriceRule;
  step?: CategoryOverrideRuleSteps;
  // Create mode
  parentId?: string;
  defaultCategoryId?: string;
  parentName?: string;
  parentType?: 'price_band' | 'extension_instance';
  rules?: IPriceRule[];
};

export const CategoryOverrideRuleModal = ({
  open,
  closeModal,
  priceSchemeId,
  parentId,
  defaultCategoryId,
  parentName,
  parentType,
  rules,
  ruleToEdit,
  step,
}: CategoryOverrideRuleModalProps): ReactElement => {
  const { nestedCategories: categories, orderedFlatCategories } = usePricingCategories(priceSchemeId);

  const resolvedParentName = parentName ?? ruleToEdit?.price_band?.name ?? ruleToEdit?.extension_instance?.name ?? '';
  const resolvedParentType: 'price_band' | 'extension_instance' =
    parentType ?? (ruleToEdit?.price_band ? 'price_band' : 'extension_instance');

  return (
    <Modal closeModal={closeModal} open={open}>
      <CategoryOverrideRuleModalContent
        closeModal={closeModal}
        priceSchemeId={priceSchemeId}
        parentId={parentId}
        parentName={resolvedParentName}
        parentType={resolvedParentType}
        defaultCategoryId={defaultCategoryId}
        categories={categories}
        flatCategories={orderedFlatCategories}
        rules={rules}
        ruleToEdit={ruleToEdit}
        defaultStep={step}
      />
    </Modal>
  );
};
